/**
 * ZnPlayer老路径用到的
 * 切换七牛SDK
 */
import { formatQNUrl, QINIU_STREAM_TYPE, QINIU_STREAM_STATUS } from 'utils/qiniu-stream-s'
import { platformConfig } from "apiUtils/ZnPlayer"
import { userActionEnum } from "@/common/enums";

/**
 * 监听流信令变化
 * @param data 信令主体
 * @param _this 组件的this
 */
export const checkQNCMD = (data, _this) => {
  const userAction = parseInt(data.userAction, 10)
  if (userAction === userActionEnum.QINIU_MIX_STREAM || userAction === userActionEnum.QINIU_DEFAULT_STREAM) {
    const { actionParam, RoomId } = data
    const { userId, streamId } = actionParam
    const formatData = {
      ...actionParam,
      url: formatQNUrl({ roomId: RoomId, hlsPlayUrl: _this.hlsPlayUrl, stream: { ...actionParam, type: QINIU_STREAM_TYPE.MIX }, platform: _this.sdkPlatform }),
      uid: userId,
      sid: streamId,
    }
    // 混流信令
    if (userAction === userActionEnum.QINIU_MIX_STREAM && _this.mixLive) {
      if (+formatData.eventType === QINIU_STREAM_STATUS.STOP) {
        _this.liveMessageShow = true
        _this.liveMessageContent = '主播暂时离开'
        _this.videoSource = []
        _this.stepOut = true
      }
      // 混流有更新或者开始
      if (+formatData.eventType === QINIU_STREAM_STATUS.REFRESH || +formatData.eventType === QINIU_STREAM_STATUS.START) {
        if (_this.fixTimer) clearTimeout(_this.fixTimer)
        _this.fixTimer = setTimeout(() => {
          _this.videoSource = [
            {
              sid: '1',
              refreshTime: Date.now(),
              src: formatData.url,
              videoType: "main",
              isPCStream: false,
            },
          ];
          _this.liveMessageShow = false;
        }, 8000)
      }
    }
    // 普通流信令
    if (userAction === userActionEnum.QINIU_DEFAULT_STREAM) {
      // 只有主流变化才执行以下逻辑
      if (formatData.type === QINIU_STREAM_TYPE.MAIN) {
        // 更新主播ID
        _this.masterId = formatData.userId

        // 没有混流的情况，监听主流变化，更新流地址
        if (+formatData.eventType === QINIU_STREAM_STATUS.START && !_this.mixLive) {
          if (_this.fixTimer) clearTimeout(_this.fixTimer)
          _this.fixTimer = setTimeout(() => {
            _this.videoSource = [
              {
                sid: '1',
                refreshTime: Date.now(),
                src: formatData.url,
                videoType: "main",
                isPCStream: false,
              },
            ];
            _this.liveMessageShow = false;
          }, 3000)
        }
        // 停止拉流
        if (+formatData.eventType === QINIU_STREAM_STATUS.STOP && !_this.mixLive) {
          _this.liveMessageShow = true
          _this.liveMessageContent = '主播暂时离开'
          _this.videoSource = []
          _this.stepOut = true
        }
      }
    }
    return 1
  }
}

/**
 * 进入直播间获取流地址
 * @param param0 roomId
 * @param _this 组件this
 */
export const entryLiveRoomQiNiu = async ({ roomId, sid, liveMode }, _this) => {
  const QN_Res: any = await platformConfig[_this.sdkPlatform].getRoomStreamInfo({ roomId, sid })
  console.log('QN_Res=====', QN_Res)
  if (+QN_Res?.code === 0) {
    const { pullStreams = [], hlsPlayUrl, mixStream } = QN_Res.body
    // 找主流
    const mainStream = pullStreams.find((stream) => stream.type === QINIU_STREAM_TYPE.MAIN)
    const relStream = mixStream || mainStream
    _this.hlsPlayUrl = hlsPlayUrl
    _this.masterId = mainStream?.userId
    if (relStream) {
      _this.videoSource = [{
        refreshTime: Date.now(),
        sid: '1',
        src: formatQNUrl({ roomId, hlsPlayUrl, stream: relStream, platform: _this.sdkPlatform }),
        videoType: 'main',
        isPCStream: !_this.checkIsMobile(pullStreams, liveMode)
      }]
    } else {
      _this.liveMessageShow = true
      _this.liveMessageContent = '主播暂时离开'
    }
  }
}
